export enum DefaultAttributeType {
  Foundational = 'Foundational',
  Interpersonal = 'Interpersonal',
  CriticalThinking = 'Critical Thinking',
  Management = 'Management'
}
